/* jshint bitwise: false */
import { setPageTitle } from '@fry/core/utils/seo';
import { round } from 'lodash';
import objectHash from 'object-hash';

(function() {
  'use strict';

  function UtilsService(
    $q,
    $window,
    $rootScope,
    $state,
    $timeout,
    Slug,
    SweetAlert,
    ObjectDiff,
    PACKAGE_VERSIONS
  ) {
    var factory = {};

    // eslint-disable-next-line max-len
    var T_DISTRIBUTION = [[0, 0.0], [1, 12.7062047362], [2, 4.3026527297], [3, 3.1824463053], [4, 2.7764451052], [5, 2.5705818356], [6, 2.4469118511], [7, 2.3646242516], [8, 2.3060041352], [9, 2.2621571628], [10, 2.228138852], [11, 2.2009851601], [12, 2.1788128297], [13, 2.1603686565], [14, 2.1447866879], [15, 2.1314495456], [16, 2.1199052992], [17, 2.1098155778], [18, 2.1009220402], [19, 2.0930240544], [20, 2.0859634473], [21, 2.0796138447], [22, 2.0738730679], [23, 2.0686576104], [24, 2.0638985616], [25, 2.0595385528], [26, 2.0555294386], [27, 2.0518305165], [28, 2.0484071418], [29, 2.0452296421], [30, 2.0422724563], [31, 2.0395134464], [32, 2.0369333435], [33, 2.0345152974], [34, 2.0322445093], [35, 2.0301079283], [36, 2.028094001], [37, 2.026192463], [38, 2.0243941639], [39, 2.02269092], [40, 2.0210753903], [41, 2.0195409704], [42, 2.0180817028], [43, 2.0166921992], [44, 2.0153675744], [45, 2.0141033889], [46, 2.0128955989], [47, 2.0117405137], [48, 2.0106347576], [49, 2.0095752371], [50, 2.0085591121], [51, 2.0075837703], [52, 2.0066468051], [53, 2.0057459953], [54, 2.0048792882], [55, 2.0040447833], [56, 2.0032407188], [57, 2.0024654593], [58, 2.0017174841], [59, 2.0009953781], [60, 2.000297822], [61, 1.999623585], [62, 1.998971517], [63, 1.9983405425], [64, 1.9977296543], [65, 1.9971379084], [66, 1.996564419], [67, 1.996008354], [68, 1.9954689314], [69, 1.9949454151], [70, 1.9944371118], [71, 1.9939433678], [72, 1.9934635667], [73, 1.9929971259], [74, 1.9925434952], [75, 1.992102154], [76, 1.9916726096], [77, 1.9912543954], [78, 1.9908470688], [79, 1.9904502102], [80, 1.9900634213], [81, 1.9896863235], [82, 1.9893185571], [83, 1.9889597802], [84, 1.988609667], [85, 1.9882679075], [86, 1.9879342062], [87, 1.9876082816], [88, 1.9872898648], [89, 1.9869786995], [90, 1.9866745407], [91, 1.9863771544], [92, 1.986086317], [93, 1.9858018143], [94, 1.9855234419], [95, 1.9852510035], [96, 1.9849843115], [97, 1.984723186], [98, 1.9844674545], [99, 1.9842169516], [100, 1.9839715185], [110, 1.9817652821], [125, 1.9791241094], [150, 1.9759053309], [200, 1.9718962236], [300, 1.9679030113], [400, 1.9659123432], [500, 1.9647198375], [600, 1.963925622], [700, 1.9633587111], [800, 1.9629337387], [900, 1.9626033295], [1000, 1.9623390808], [1500, 1.9615467539], [2000, 1.9611508261], [2500, 1.9609133448], [3000, 1.9607550553]];

    factory.guid = function() {
      /* eslint-disable */
      // Came from https://gist.github.com/jed/982883, so let's not eslint it
      var b = function(a) {
        if (a) {
          return (a ^ Math.random() * 16 >> a / 4).toString(16);
        } else {
          return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, b);
        }
      };

      return b();
      /* eslint-enable */
    };

    factory.now = function(options) {
      options = options || {};

      var date = new Date();
      var dateStr;

      if (options.dateOnly) {
        dateStr = new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString();
        dateStr = dateStr.slice(0, 10);
      } else {
        dateStr = new Date().toISOString();
      }

      return dateStr;
    };

    factory.fromDate = function(datestring) {
      return new Date(datestring);
    };

    factory.flatten = function(obj, result, prefix) {
      if (_.isArray(obj.categories) && obj.categories.length) {
        _.forEach(obj.categories, function(subcat) {
          factory.flatten(subcat, result, prefix ? prefix + ' - ' + subcat.name : subcat.name);
        });
      } else {
        result[prefix] = obj;
      }

      return result;
    };

    /* TODO: Need to unit test this */
    factory.flattenDeep = function(obj, result, prop) {
      result.push(obj[prop]);

      if (_.isArray(obj.categories) && obj.categories.length) {
        _.forEach(obj.categories, function(subcat) {
          factory.flattenDeep(subcat, result, prop);
        });
      }

      return result;
    };

    factory.flattenCategories = function(categories, root, parent) {
      var flatten = {};

      var flat = function(categories, root, parent) {
        if (categories === undefined) {
          return;
        }

        categories.forEach(function(category) {
          flatten[category._id] = {
            root: root.name,
            value: category.name,
            key: category._id,
            rootId: root._id,
            parent: parent._id
          };

          flat(category.categories, root, category);
        });
      };

      flat(categories, root, parent);
      return flatten;
    };

    factory.slugify = function(title) {
      return Slug.slugify(title);
    };

    factory.isIdAutogenerated = function(id) {
      return /^[0-9A-Fa-f]+-[0-9A-Fa-f]+-[0-9A-Fa-f]+-[0-9A-Fa-f]+-[0-9A-Fa-f]+$/.test(id);
    };

    factory.confirm = function(options) {
      options = options || {};
      var defaultOptions = {
        showCancelButton: false,
        text: '',
        confirmButtonText: 'OK'
      };
      options = _.assign({}, defaultOptions, options);

      var def = $q.defer();
      factory.swal(options, function(isConfirm) {
        if (!isConfirm) {
          def.reject({ status: 510, message: 'User cancelled' });
        } else {
          def.resolve();
        }
      });
      return def.promise;
    };

    factory.swal = function(options, callback) {
      var defaultConfig = {
        title: '',
        text: '',
        type: null,
        allowOutsideClick: false,
        showConfirmButton: true,
        showCancelButton: false,
        closeOnConfirm: true,
        closeOnCancel: true,
        confirmButtonText: 'OK',
        confirmButtonColor: '#8CD4F5',
        cancelButtonText: 'Cancel',
        imageUrl: null,
        imageSize: null,
        timer: null,
        customClass: '',
        html: false,
        animation: true,
        allowEscapeKey: true,
        inputType: 'text',
        inputPlaceholder: '',
        inputValue: '',
        showLoaderOnConfirm: false
      };
      var opts = _.assignIn({}, defaultConfig, options);

      setTimeout(function() {
        SweetAlert.swal(opts, callback);
      }, 0);
    };

    factory.showError = function(error, callback) {
      console.warn(error);
      var msg;
      if (error === undefined) {
        msg = 'Unknown error';
      } else if (error.reason) {
        msg = error.reason;
      } else {
        msg = (error.data) ? (error.data.message || error.data) : error.message;
      }

      factory.swal({
        title: msg || 'Unknown error',
        type: 'error'
      }, callback);
    };

    factory.unauthorized = function(error, callback) {
      var message = error.message;

      factory.swal({
        title: message || 'You are not authorised to access this page',
        type: 'error'
      }, function() {
        if (callback === undefined) {
          $window.history.back();
        } else {
          return callback();
        }
      });
    };

    factory.asyncFilter = function(data, func) {
      if (data === undefined) {
        return $q.when([]);
      }

      return $q.all([
        $q.when(data),
        $q.all(data.map(func))
      ])
        .then(function(results) {
          return _.zip(results[0], results[1])
            .filter(function(result) {
              return result[1];
            })
            .map(function(result) {
              return result[0];
            });
        });
    };

    factory.recordLog = function(doc, action, actor, options) {
      doc.dates = doc.dates || [];
      doc.dates.push(
        angular.extend({}, { date: factory.now(), action: action, actor: actor }, options)
      );
    };

    /**
     * Get any number of arguments and return all concatenated as a single string
       suitable for text search + lowercase it.
     *
     * @static
     * @returns {String} Returns the concatenated lowercased string
     * @example
     * safeStr(1, undefined, 'my name')
     * // => ' 1 my name'
    **/
    factory.safeLowerStr = function() {
      var result = '';
      for (var i = 0; i < arguments.length; i++) {
        result = result + ' ' + (arguments[i] ? arguments[i] : '');
      }

      return result.toLowerCase().trim();
    };

    /**
     * Creates an array of unique objects that are included in all of the provided
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of shared values.
     * @example
     * _.intersection([
     *     {'id': 1, 'name': 'jake' },
     *     {'id':4, 'name': 'jenny'}
     *   ], [
     *     {'id': 1, 'name': 'jake' },
     *     {'id': 9, 'name': 'nick'}
     *   ]);
     * // => [{'id': 1, 'name': 'jake' } ]
     */
    factory.intersectionObjects = function(array) {
      var slice = Array.prototype.slice; // added this line as a utility
      var rest = slice.call(arguments, 1);
      return _.filter(_.uniq(array), function(item) {
        return _.every(rest, function(other) {
          // return _.indexOf(other, item) >= 0;
          return _.some(other, function(element) { return _.isEqual(element, item); });
        });
      });
    };

    factory.stddev = function(values) {
      if (!values || !values.length) {
        return 0;
      }

      var avg = factory.avg(values);
      return Math.sqrt(
        values.reduce(function(a, b) { return a + Math.pow(b - avg, 2); }, 0) / (values.length - 1)
      );
    };

    factory.isBlank = function(item) {
      var map = {
        number: _.isNaN(item),
        boolean: false,
        function: false
      };

      if (_.indexOf(_.keys(map), typeof item) > -1) {
        return map[typeof item];
      }

      return _.isEmpty(item);
    };

    factory.bool = function(value) {
      if (_.isObject(value) || _.isArray(value)) {
        return !_.isEmpty(value);
      }

      return !!value;
    };

    factory.avg = function(values) {
      if (!values || !values.length) {
        return NaN;
      }

      return values.reduce(function(a, b) { return a + b; }) / values.length;
    };

    factory.sum = function(values) {
      return values.reduce(function(a, b) { return a + b; }, 0);
    };

    factory.t_interval = function(values) {
      if (values.length === 0) {
        return 0;
      }

      var dof = values.length - 1;
      var t = _.find(T_DISTRIBUTION, function(item, idx) {
        if (idx < T_DISTRIBUTION.length - 1) {
          return dof >= item[0] && dof < T_DISTRIBUTION[idx + 1][0];
        }

        return dof >= item[0];
      });

      var std = factory.stddev(values);
      return (t[1] * std) / Math.sqrt(values.length);
    };

    factory.getRate = function(numerator, denominator) {
      if (!denominator || !numerator) {
        return 0;
      }

      return Math.round((numerator / denominator) * 100);
    };

    factory.round = function(value, decimals) {
      if (decimals === undefined) {
        decimals = 0;
      }

      var negate = value < 0;

      if (negate) {
        value *= -1;
      }

      var res = round(value, decimals);

      if (negate) {
        res *= -1;
      }
      return res.toFixed(decimals);
    };

    factory.filterButtons = function(buttons) {
      return factory.asyncFilter(buttons, function(button) {
        if (button.showCondition === undefined) {
          return true;
        }

        return $q.when(button.showCondition())
          .then(function(res) {
            return res === undefined ? true : res;
          })
          .catch(function() {
            return false;
          });
      });
    };

    factory.stringContains = function(sourceTokens, queryTokens) {
      for (var i = 0; i < queryTokens.length; i++) {
        for (var j = 0; j < sourceTokens.length; j++) {
          if (sourceTokens[j].indexOf(queryTokens[i]) > -1) {
            return true;
          }
        }
      }

      return false;
    };

    factory.go = function(name, params, options) {
      if (options.tryBack && $rootScope.previousState && !$rootScope.previousState.abstract) {
        return $state.go($rootScope.previousState, $rootScope.previousStateParams);
      }

      return $state.go(name, params);
    };

    factory.delayedPromise = function(data) {
      var def = $q.defer();
      $timeout(function() {
        def.resolve(data);
      }, 2000);
      return def.promise;
    };

    factory.removeDisabledItems = function(items) {
      function checkSubItems(subItems) {
        return _.filter(subItems, function(subItem) {
          if (!subItem.disabled && subItem.categories && subItem.categories.length) {
            subItem.categories = checkSubItems(subItem.categories);
          }

          return !subItem.disabled;
        });
      }

      return checkSubItems(items);
    };

    factory.removeItemFromListById = function(list, idToRemove) {
      var position;
      _.forEach(list, function(obj, i) {
        if (obj._id === idToRemove) {
          position = i;
        }
      });

      list.splice(position, 1);
    };

    /**
     * Return whether to show a tree or a simple select
     */
    factory.suitableForSimpleField = function(items) {
      // this should not happen but it also should not fail badly.
      if (_.isUndefined(items)) {
        return true;
      }

      var categories;
      for (var i = 0; i < items.length; i++) {
        categories = items[i].categories || [];
        for (var j = 0; j < categories.length; j++) {
          if ((categories[j].categories || []).length > 0) {
            return false;
          }
        }
      }
      return true;
    };

    factory.suitableForSuperSimpleField = function(items) {
      // this should not happen but it also should not fail badly.
      if (_.isUndefined(items)) {
        return true;
      }

      var categories;
      for (var i = 0; i < items.length; i++) {
        categories = items[i].categories || [];
        if (categories.length > 0) {
          return false;
        }
      }
      return true;
    };

    /* This is supposedly the way Google does it
       It just adds parents prototype to child
    */
    factory.extends = function(child, parent) {
      var F = function() {};
      F.prototype = parent.prototype;
      child.prototype = new F();
      child._superClass = parent.prototype;
      child.prototype.constructor = child;
    };

    factory.generateColor = function() {
      return '#' + _.padStart(Math.floor(Math.random() * 16777215).toString(16), 6, '0');
    };

    /* eslint-disable */
    /**
     * Generates a random password
     *
     * @param numLc Number of lowercase letters to be used (default 4)
     * @param numUc Number of uppercase letters to be used (default 4)
     * @param numDigits Number of digits to be used (default 4)
     * @param numSpecial Number of special characters to be used (default 2)
     * @returns {*|string|String}
     */
    factory.generatePassword = function(numLc, numUc, numDigits, numSpecial) {
      numLc = numLc || 4;
      numUc = numUc || 4;
      numDigits = numDigits || 4;
      numSpecial = numSpecial || 2;

      //* Get a new character from the list, excluding I, l, o, O and 0
      function newCharacter() {
        var characters = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz123456789';
        return characters.charAt(Math.floor(Math.random() * characters.length));
      }

      var lcLetters = 'abcdefghijklmnopqrstuvwxyz';
      var ucLetters = lcLetters.toUpperCase();
      var numbers = '0123456789';
      var special = '!?=#*$@+-.';

      var getRand = function(values) {
        return values.charAt(Math.floor(Math.random() * values.length));
      }

      //+ Jonas Raoni Soares Silva
      //@ http://jsfromhell.com/array/shuffle [v1.0]
      function shuffle(o) { //v1.0
        for (var j, x, i = o.length; i; j = Math.floor(Math.random() * i), x = o[--i], o[i] = o[j], o[j] = x) ;
        return o;
      };

      var pass = [];
      for (var i = 0; i < numLc; ++i) {
        pass.push(getRand(lcLetters));
      }
      for (var i = 0; i < numUc; ++i) {
        pass.push(getRand(ucLetters));
      }
      for (var i = 0; i < numDigits; ++i) {
        pass.push(getRand(numbers));
      }
      for (var i = 0; i < numSpecial; ++i) {
        pass.push(getRand(special));
      }

      var shuffledPass = shuffle(pass).join('');

      // Replace certain characters that cause problems for people with dyslexia
      return shuffledPass.replace(/[0oOIl]/g, newCharacter());
    }
    /* eslint-enable */

    factory.separateByUppercase = function(str, join) {
      str = str || '';
      join = join || ' ';

      return str.split(/(?=[A-Z])/).join(join);
    };

    factory.slowDown = function(duration) {
      return function(result) {
        console.log('Slowing down by', duration);
        var def = $q.defer();
        $timeout(function() {
          def.resolve(result);
        }, duration);
        return def.promise;
      };
    };

    function cmpVersions(a, b) {
      var pa = a.split('.');
      var pb = b.split('.');
      for (var i = 0; i < 3; i++) {
        var na = Number(pa[i]);
        var nb = Number(pb[i]);
        if (na > nb) { return 1; }
        if (nb > na) { return -1; }
        if (!isNaN(na) && isNaN(nb)) { return 1; }
        if (isNaN(na) && !isNaN(nb)) { return -1; }
      }
      return 0;
    }

    factory.validVersion = function(version) {
      try {
        return cmpVersions(PACKAGE_VERSIONS.frontend, version) > -1;
      } catch (err) {
        console.log('Could not parse versions', err);
        return true;
      }
    };

    factory.diff = function(a, b) {
      return ObjectDiff.diff(a, b);
    };

    // eslint-disable-next-line max-len
    var emailPattern = new RegExp('^([A-Za-z0-9_\\-\\.\\+\\\'])+\@([A-Za-z0-9_\\-\\.])+\\.([A-Za-z]{2,8})$');
    factory.validateEmail = function(email, domains) {
      if (_.isEmpty(email)) {
        return true;
      }
      if (!emailPattern.test(email.trim())) {
        return false;
      }

      if (!_.isEmpty(domains)) {
        var res = _.some(domains, function(dom) {
          return email.endsWith(dom);
        });
        if (!res) {
          return false;
        }
      }

      return true;
    };

    factory.toArray = function(value) {
      if (_.isEmpty(value)) {
        return [];
      } else if (_.isArray(value)) {
        return value;
      } else if (_.isString(value)) {
        return [value];
      }

      console.log('Nonsense value');
      return value;
    };

    factory.hashDoc = function(value, options) {
      options = options || {};
      var excludedKeys = options.excludedKeys || ['_rev', 'kzHash', 'kzPrevHash', 'saveInfo'];
      return objectHash(value,
        {
          excludeKeys: function(key) {
            return excludedKeys.indexOf(key) !== -1;
          },
          unorderedArrays: true,
          respectType: false
        }
      );
    };

    factory.isEqual = function(doca, docb, options) {
      doca = JSON.parse(JSON.stringify(doca));
      docb = JSON.parse(JSON.stringify(docb));
      return factory.hashDoc(doca, options) === factory.hashDoc(docb, options);
    };

    factory.getMainRev = function(rev) {
      if (rev === undefined) {
        return 0;
      }

      return parseInt(rev.split('-')[0]);
    };

    factory.clearRestricted = function(restricted) {
      if (!_.isObject(restricted)) {
        return {};
      }

      // Not having 'by' means it's not defined at all
      if (!factory.bool(restricted.by)) {
        return {};
      }

      var rest = {
        by: restricted.by
      };

      var to = restricted.to;

      if (!factory.bool(to)) {
        return rest;
      }

      if (!_.isArray(to)) {
        to = [to];
      }

      if (to.indexOf('any') !== -1) {
        return rest;
      }

      rest.to = to;
      return rest;
    };

    factory.evalComplex = function(filterObj, handleExp, options) {
      options = options || {};
      var defaultValue = options.default || true;
      var _eval,
          _evalExp,
          _evalOp;

      _evalExp = function(exp) {
        if (!exp) {
          return defaultValue;
        }

        return handleExp(exp);
      };

      _evalOp = function(subFilter) {
        if (subFilter.operator === 'not') {
          return !_eval(subFilter.child);
        }

        if (_.isEmpty(subFilter.children)) {
          return defaultValue;
        }

        var value;
        if (subFilter.operator === 'and') {
          value = _.every(subFilter.children, _eval);
        } else if (subFilter.operator === 'or') {
          value = _.some(subFilter.children, _eval);
        } else {
          console.log('Unknown operator', subFilter.operator);
          value = defaultValue;
        }
        return value;
      };

      _eval = function(subFilter) {
        if (_.isEmpty(subFilter)) {
          return defaultValue;
        }

        var value;
        if (subFilter.type === 'operator') {
          value = _evalOp(subFilter);
        } else if (subFilter.type === 'expression') {
          value = _evalExp(subFilter.expression);
        } else {
          console.log('Unknown type', subFilter.type);
          value = defaultValue;
        }
        return value;
      };

      return _eval(filterObj);
    };

    /**
     * Retry given function if specific error code appears
     *
     * @param {function} func The function to retry - should return a promise
     * @param {*} times Number of times it should be retried
     * @param {*} codes List of error codes that triggers retry
     */
    factory.retryPromise = function(func, times, codes) {
      codes = codes || [];

      var tries = 0;
      var catcher = function(error) {
        if (tries < times && (error && codes.indexOf(error.status)) !== -1) {
          tries += 1;
          return func(true, error)
            .catch(catcher);
        }

        return $q.reject(error);
      };

      return func()
        .catch(catcher);
    };

    factory.filtersToSearchModel = function(filters) {
      // combine all filters with ORs and ANDs (even we only use ANDs)
      // returns {
      //   eventType_versionGroupId: [[{}, {}],[{}, {}],[{}, {}]],
      //   blueprint: [[{}, {}],[{}, {}],[{}, {}]]
      // }

      var results = {};
      _.forEach(filters, function(filter) {
        if (_.isUndefined(results[filter.dataType])) {
          results[filter.dataType] = [];
        }

        results[filter.dataType].push(filter);
      });

      var r = {};
      _.forEach(results, function(value, key) {
        if (_.isArray(value)) {
          r[key] = _.map(value, function(itm) {
            return [itm];
          });
        } else {
          r[key] = [value];
        }
      });

      return r;
    };

    // A MurmurHash2 implementation, from @emotion/hash
    // https://github.com/emotion-js/emotion/blob/a8b9a7f049f9773a57d76c7b380d8e48110f1569/packages/hash/src/index.js
    // Read more about the MurmurHash here: https://en.wikipedia.org/wiki/MurmurHash
    /* eslint-disable no-bitwise,no-mixed-operators,default-case,no-fallthrough */
    factory.hash = function(str) {
      var l = str.length;
      var h = l ^ l;
      var i = 0;
      var k;

      while (l >= 4) {
        k =
          (str.charCodeAt(i) & 0xff) |
          ((str.charCodeAt(++i) & 0xff) << 8) |
          ((str.charCodeAt(++i) & 0xff) << 16) |
          ((str.charCodeAt(++i) & 0xff) << 24);

        k =
          (k & 0xffff) * 0x5bd1e995 + ((((k >>> 16) * 0x5bd1e995) & 0xffff) << 16);
        k ^= k >>> 24;
        k =
          (k & 0xffff) * 0x5bd1e995 + ((((k >>> 16) * 0x5bd1e995) & 0xffff) << 16);

        h =
          ((h & 0xffff) * 0x5bd1e995 +
            ((((h >>> 16) * 0x5bd1e995) & 0xffff) << 16)) ^
          k;

        l -= 4;
        ++i;
      }

      switch (l) {
        case 3:
          h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
          h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
          h ^= str.charCodeAt(i) & 0xff;
          h =
            (h & 0xffff) * 0x5bd1e995 +
            ((((h >>> 16) * 0x5bd1e995) & 0xffff) << 16);
      }

      h ^= h >>> 13;
      h = (h & 0xffff) * 0x5bd1e995 + ((((h >>> 16) * 0x5bd1e995) & 0xffff) << 16);
      h ^= h >>> 15;

      return (h >>> 0).toString(36);
    };
    /* eslint-enable no-bitwise,no-mixed-operators,default-case,no-fallthrough */

    factory.getMemorySizeOfObject = function(obj) {
      var bytes = 0;

      function sizeOf(obj) {
        if (obj !== null && obj !== undefined) {
          // eslint-disable-next-line default-case
          switch (typeof obj) {
            case 'number':
              bytes += 8;
              break;
            case 'string':
              bytes += obj.length * 2;
              break;
            case 'boolean':
              bytes += 4;
              break;
            case 'object':
              var objClass = Object.prototype.toString.call(obj).slice(8, -1);
              if (objClass === 'Object' || objClass === 'Array') {
                // eslint-disable-next-line no-restricted-syntax
                for (var key in obj) {
                  // eslint-disable-next-line no-prototype-builtins
                  if (!obj.hasOwnProperty(key)) {
                    // eslint-disable-next-line no-continue
                    continue;
                  }
                  sizeOf(obj[key]);
                }
              } else {
                bytes += obj.toString().length * 2;
              }
              break;
          }
        }
        return bytes;
      }

      return sizeOf(obj);
    };

    // See utils/seo.ts in the new Angular app
    factory.setPageTitle = function(title) {
      setPageTitle(title);
    };

    // handle reordering
    /**
     * Get a new index based on the previous and next indexes.
     * @param  {Number} prev The previous index (optional).
     * @param  {Number} next The next index.
     * @return {Number}      The new index.
     */
    factory.getNewOrderIndex = function(prev, next) {
      prev = prev || 0;
      return next ? (prev + next) / 2 : prev + 1;
    };

    // download a CSV file
    factory.downloadCSV = function(data, filename) {
      var blob = new Blob([data], { type: 'text/csv;charset=utf-8;' });
      var link = document.createElement('a');
      var url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };

    return factory;
  }

  UtilsService.$inject = [
    '$q',
    '$window',
    '$rootScope',
    '$state',
    '$timeout',
    'Slug',
    'SweetAlert',
    'ObjectDiff',
    'PACKAGE_VERSIONS'
  ];

  angular.module('blocks.utils')
    .factory('UtilsService', UtilsService);
})();
